import { CustomFilterMeta } from '@src/main/modules/messages/ui/mailbox/views/mailbox/mailbox.types';

type CriteriaBase = {
  message?: string;
  subject?: string;
  sendBy?: string;
  sendDateFrom?: string;
  sendDateTo?: string;
  recipient?: string;
};

export const mapFiltersToCriteria = <T extends CriteriaBase>(
  filters: CustomFilterMeta,
  emptyCriteria: T,
): T => {
  const criteria = { ...emptyCriteria };

  if (filters.global?.value != null) criteria.message = filters.global.value;
  if (filters.subject?.constraints?.[0]?.value != null) {
    criteria.subject = filters.subject.constraints[0].value;
  }
  if (filters.sendBy?.constraints?.[0]?.value != null) {
    criteria.sendBy = filters.sendBy.constraints[0].value;
  }
  if (filters.sendDate?.constraints?.[0]?.value != null) {
    const [startDate, endDate] = filters.sendDate.constraints[0].value;
    if (startDate) criteria.sendDateFrom = startDate.toISOString();
    if (endDate) criteria.sendDateTo = endDate.toISOString();
  }
  if (filters.message?.constraints?.[0]?.value != null) {
    criteria.message = filters.message.constraints[0].value;
  }
  if (filters.recipients?.constraints?.[0]?.value != null) {
    criteria.recipient = filters.recipients.constraints[0].value;
  }

  return criteria;
};
